import $ from 'jquery';
import { showAjaxLoader, hideAjaxLoader } from '@invia/web-library/helpers/ajaxLoader';


export const init = () => {
	$('#nl_city_id').change(function () {
		var nl_city_id = parseInt($(this).val());

		if (nl_city_id <= 0) {
			var activeDepartments = getSelectOptionValues($('#nl_department_id'));
			hideInactiveOptions($('#nl_department_id'), activeDepartments);
		} else {
			$.ajax({
				url: '/direct/corporate_career/ajax-get-departments-by-city/',
				data: {
					nl_city_id: nl_city_id,
				},
				success: function (options) {
					hideInactiveOptions($('#nl_department_id'), options);
				},
				beforeSend: showAjaxLoader,
				complete: hideAjaxLoader,
			});
		}
	});

	$('#nl_department_id').change(function () {
		var nl_department_id = parseInt($(this).val());

		if (nl_department_id <= 0) {
			var activeCities = getSelectOptionValues($('#nl_city_id'));
			hideInactiveOptions($('#nl_city_id'), activeCities);
		} else {
			$.ajax({
				url: '/direct/corporate_career/ajax-get-cities-by-department/',
				data: {
					nl_department_id: nl_department_id,
				},
				success: function (options) {
					hideInactiveOptions($('#nl_city_id'), options);
				},
				beforeSend: showAjaxLoader,
				complete: hideAjaxLoader,
			});
		}
	});
};

const getSelectOptionValues = ($elem) => {
	var $options = $elem.find('option');

	var values = $.map($options, function (option) {
		return parseInt(option.value);
	});

	return values;
};

const hideInactiveOptions = ($elem, activeOptions) => {
	$.each($elem.find('option[value!="0"][value!="-1"]'), function (i, option) {
		//$.each($elem.find('option'), function(i, option) {
		if (activeOptions.indexOf(parseInt($(option).attr('value'))) == -1) {
			$(option).attr('hidden', 'hidden');
		} else {
			$(option).removeAttr('hidden');
		}
	});
};
